<template>
  <div>
    <v-row>
      <v-col class="d-flex" cols="12" md="5">
        <app-text-search-field
          @filter="showFilter = !showFilter"
          @input="handleSearchInput($event)"
        />
      </v-col>
      <v-col class="text-right" cols="12" md="7">
        <v-btn
          class="mr-2"
          bottom
          large
          color="primary"
          v-if="$acl.can('productCreateEdit')"
          @click="openStoreProductForm()"
        >
          Novo
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              bottom
              large
              outlined
              color="secondary"
              v-if="$acl.canView('productCreateEdit')"
              v-bind="attrs"
              v-on="on"
            >
              Opções
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item @click="openExportProductForm()">
              <v-list-item-title> Exportar </v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPurchaseProductForm()">
              <v-list-item-title>
                Exportar sugestão de compra</v-list-item-title
              >
            </v-list-item>
            <v-list-item
              v-if="$acl.can('productCreateEdit')"
              @click="$router.push({ name: 'ProductMassUpdateIndex' })"
            >
              <v-list-item-title> Atualização em massa </v-list-item-title>
            </v-list-item>
            <v-list-item
              @click="$router.push({ name: 'MassUpdateBatchesIndex' })"
            >
              <v-list-item-title> Histórico de atualização em massa </v-list-item-title>
            </v-list-item>
            <v-list-item to="/produtos/movimento-estoque">
              <v-list-item-title> Movimento de estoque </v-list-item-title>
            </v-list-item>
            <template v-if="$acl.can('ProductsReportIndex')">
              <v-list-item to="/produtos/relatorio-de-produtos">
                <v-list-item-title> Relatório de estoque </v-list-item-title>
              </v-list-item>
            </template>
            <template v-if="$acl.can('ProductsByBrandReportIndex')">
              <v-list-item to="/produtos/relatorio-de-produtos-por-marca">
                <v-list-item-title> Relatório por marca </v-list-item-title>
              </v-list-item>
            </template>
            <template v-if="$acl.can('ProductsByBrandReportIndex')">
              <v-list-item
                to="/produtos/relatorio-de-movimentacao-estoque-por-marca"
              >
                <v-list-item-title>
                  Relatório movimentação estoque por marca
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="d-flex align-center" v-if="showFilter">
      <v-col cols="12" md="3">
        <ClassificacaoFiscalSelect
          @input="select()"
          v-model="searchParams.classificacao_fiscal"
        />
      </v-col>
      <v-col cols="12" md="3">
        <CategoriesSearch
          @input="handleRelationshipInput($event, 'category_id')"
        />
      </v-col>
      <v-col cols="12" md="3">
        <BrandsSearch @input="handleRelationshipInput($event, 'brand_id')" />
      </v-col>
      <v-col cols="12" md="3">
        <SupplierSearch
          @input="handleRelationshipInput($event, 'supplier_id')"
        />
      </v-col>

      <v-col cols="12" md="3">
        <v-text-field
          @input="select()"
          v-model="searchParams.purchase_id"
          label="Id Compra"
        />
      </v-col>

      <v-col cols="12" md="3">
        <app-number-field
          v-model="searchParams.available_stock_more_than"
          :allowNegative="true"
          :forceZero="false"
          label="Estoque maior que"
          @change="select()"
        />
      </v-col>
      <v-col cols="12" md="3">
        <app-number-field
          v-model="searchParams.available_stock_less_than"
          :allowNegative="true"
          :forceZero="false"
          label="Estoque menor que"
          @change="select()"
        />
      </v-col>

      <v-col>
        <v-text-field
          v-model="searchParams.manufacturer_id"
          prepend-inner-icon="mdi-magnify"
          placeholder="Código do fabricante"
          v-debounce:300ms="select"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-switch
          v-model="searchParams.low_stock"
          label="Abaixo do estoque mínimo"
          @change="select()"
        />
      </v-col>
      <v-col cols="12" md="3">
        <app-select
          clearable
          :items="headersABC"
          v-model="searchParams.stock_abc_curve"
          label="Curva ABC Estoque"
          @input="select()"
        />
      </v-col>
      <v-col cols="12" md="3">
        <app-select
          clearable
          :items="headersABC"
          v-model="searchParams.sale_abc_curve"
          label="Curva ABC Vendas"
          @input="select()"
        />
      </v-col>
      <v-col cols="12" md="3">
        <v-select
          v-model="searchParams.empty_brand_or_category"
          :items="empty_filters"
          label="Filtros Especiais"
          @change="select()"
          clearable
        />
      </v-col>
      <v-col cols="12" md="12">
        <v-chip-group @change="select()" v-model="searchParams.status" column>
          <v-chip filter :value="1" color="primary">Ativo</v-chip>
          <v-chip filter :value="0">Inativo</v-chip>
        </v-chip-group>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <div
          v-if="selectedProductIds.length > 0"
          class="d-flex align-center justify-space-between px-4 py-3 mb-2"
          style="background: #f8fafc; border-radius: 4px; border: 1px solid #e0e0e0;"
        >
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2"
              >mdi-checkbox-multiple-marked</v-icon
            >
            <span class="font-weight-medium" style="font-size: 1.1rem;">
              {{ selectedProductIds.length }} produto{{ pluralS }} selecionado{{
                pluralS
              }}
            </span>
          </div>
          <div class="d-flex align-center" style="gap: 12px;">
            <v-btn @click="openImageModal" color="primary" elevation="1">
              <v-icon left>mdi-image</v-icon>
              Imagens
            </v-btn>
            <v-btn @click="openModal" color="primary" elevation="1">
              <v-icon left>mdi-pencil</v-icon>
              Atualizar
            </v-btn>
            <v-btn @click="handleExportSelected" color="success" elevation="1">
              <v-icon left>mdi-file</v-icon>
              Exportar
            </v-btn>
            <v-btn @click="handleClearSelected()" outlined color="secondary">
              <v-icon left>mdi-close-circle-outline</v-icon>
              Limpar
            </v-btn>
          </div>
        </div>

        <v-data-table
          ref="productTable"
          @click:row="openStoreProductForm($event.id)"
          :headers="headers"
          :items="products.data"
          :mobile-breakpoint="0"
          :items-per-page="-1"
          :loading="loading"
          hide-default-footer
          :item-class="checkIfRowIsUpdated"
          show-expand
        >
          <template v-slot:[`top`]>
            <div class="d-flex justify-space-between">
              <div>
                <v-switch
                  v-model="expanded"
                  small
                  hide-details
                  label="Exibir estoque"
                />
              </div>
              <div class="text-right">
                <v-menu :close-on-content-click="false">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="text-capitalize"
                      color="primary"
                      text
                      dark
                      v-bind="attrs"
                      v-on="on"
                      small
                    >
                      Editar Colunas
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item-group>
                      <template v-for="(item, index) in allHeaders">
                        <v-list-item
                          :key="index"
                          :value="item"
                          active-class="deep-purple--text text--accent-4"
                        >
                          <v-list-item-content>
                            <v-list-item-title
                              v-text="item.text"
                            ></v-list-item-title>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-checkbox
                              v-model="headers"
                              :value="item"
                            ></v-checkbox>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-menu>
              </div>
            </div>
          </template>

          <template v-slot:[`item.image`]="{ item }">
            <div
              class="py-2"
              @click.stop="openProductImagesModal(item.id)"
              style="cursor: pointer;"
            >
              <v-img
                v-if="getProductImage(item)"
                :src="getProductImage(item)"
                aspect-ratio="1"
                width="60"
                height="60"
                contain
                class="rounded"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    align="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-2"
                      size="20"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-avatar v-else color="grey lighten-3" size="60" class="rounded">
                <v-icon color="grey lighten-1">mdi-image-off</v-icon>
              </v-avatar>
            </div>
          </template>

          <template v-slot:[`item.name`]="{ item }">
            {{ item.name }}
            <small class="text--secondary"> #{{ item.code }} </small>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <small class="ml-4" v-bind="attrs" v-on="on">
                  {{ item.stock_abc_curve }} |
                </small>
              </template>
              <span>Estoque</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <small v-bind="attrs" v-on="on">
                  {{ item.sale_abc_curve }}
                </small>
              </template>
              <span>Vendas</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.price_cash`]="{ item }">
            <div @click.stop="handleUpdateCost(item)">
              {{ $format.decimal(item.product_variants[0].price_cash) }}
            </div>
          </template>
          <template v-slot:[`item.price_forward`]="{ item }">
            {{ $format.decimal(item.product_variants[0].price_forward) }}
          </template>

          <template
            v-if="$acl.isManager() || $acl.isAdministrativeAssistant()"
            v-slot:[`item.clone`]="{ item }"
          >
            <v-btn
              small
              text
              class="rounded-full"
              icon
              @click.stop="handleClone(item.id)"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
          </template>
          <template
            v-if="$acl.isManager() || $acl.isAdministrativeAssistant()"
            v-slot:header.checkbox
          >
            <v-checkbox
              :input-value="allSelected"
              :indeterminate="selectedProductIds.length > 0 && !allSelected"
              @change="toggleSelectAll"
              color="secondary"
              hide-details
              class="ma-0 pa-0"
              style="margin:0;padding:0;"
            />
          </template>

          <template
            v-if="$acl.isManager() || $acl.isAdministrativeAssistant()"
            v-slot:[`item.checkbox`]="{ item }"
          >
            <div class="d-flex justify-center align-center">
              <v-checkbox
                v-model="selectedProductIds"
                :value="item.id"
                @click.stop
                hide-details
                class="ma-0 pa-0"
                style="margin:0;padding:0;"
              />
            </div>
          </template>

          <template v-slot:[`item.profit`]="{ item }">
            {{ $format.decimal(item.product_variants[0].profit) }}%
          </template>

          <template v-slot:[`item.cost_updated_at`]="{ item }">
            {{ $format.dateBr(item.product_variants[0].cost_updated_at) }}
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <status-chip :value="item.status" />
          </template>

          <template v-slot:[`item.brand`]="{ item }">
            {{ item.brand ? item.brand.name : "______ " }}
          </template>

          <template v-slot:[`item.category`]="{ item }">
            {{ item.category ? item.category.name : "______ " }}
          </template>
          <template v-slot:[`item.weight_gross`]="{ item }">
            {{
              item.product_variants[0].weight_gross
                ? `${$format.kilo(item.product_variants[0].weight_gross)}`
                : "______ "
            }}
          </template>
          <template v-slot:[`item.weight_net`]="{ item }">
            {{
              item.product_variants[0].weight_net
                ? `${$format.kilo(item.product_variants[0].weight_net)}`
                : "______ "
            }}
          </template>

          <template v-slot:[`item.supplier`]="{ item }">
            {{ item.supplier ? item.supplier.name : "______ " }}
          </template>

          <template v-slot:expanded-item="{ item }">
            <td></td>
            <td colspan="99">
              <v-simple-table class="expanded-table" dense>
                <template v-slot:default>
                  <tbody>
                    <template
                      v-for="(product_company, index) in item
                        .product_variants[0].product_companies"
                    >
                      <tr :key="index" v-if="showStockLine(product_company)">
                        <td style="width: 10%">
                          <small class="mr-2">
                            {{ product_company.company.short_name }}
                          </small>
                          <StockAlert
                            v-if="hasStock(product_company)"
                            :productCompany="product_company"
                          />
                        </td>
                        <td style="width: 10%">
                          <ProductStockLabel
                            :productCompany="product_company"
                          />
                        </td>
                        <td style="width: 10%">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <small v-bind="attrs" v-on="on">
                                <v-icon small left>
                                  mdi-package-variant-closed-remove
                                </v-icon>
                                {{
                                  $format.decimal(
                                    product_company.reserved_stock
                                  )
                                }}
                              </small>
                            </template>
                            <span>Reservado</span>
                          </v-tooltip>
                        </td>
                        <td style="width: 10%">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <small v-bind="attrs" v-on="on">
                                <v-icon small left> mdi-dolly </v-icon>
                                {{
                                  $format.decimal(
                                    product_company.expedition_stock
                                  )
                                }}
                              </small>
                            </template>
                            <span>Expedição</span>
                          </v-tooltip>
                        </td>
                        <td style="width: 10%">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <small v-bind="attrs" v-on="on">
                                <v-icon small left
                                  >mdi-view-grid-outline</v-icon
                                >
                                {{
                                  $format.decimal(product_company.physic_stock)
                                }}
                              </small>
                            </template>
                            <span>Físico</span>
                          </v-tooltip>
                        </td>
                        <td style="width: 10%">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <small v-bind="attrs" v-on="on">
                                <v-icon small left>
                                  mdi-truck-fast-outline
                                </v-icon>
                                {{
                                  $format.decimal(
                                    product_company.transfer_stock
                                  )
                                }}
                              </small>
                            </template>
                            <span>Em Transferência</span>
                          </v-tooltip>
                        </td>
                        <td></td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
          </template>
        </v-data-table>
        <app-pagination :data="products" @click="select($event)" />
      </v-col>
    </v-row>
    <StoreProductForm
      @store="handleUpdatedProduct($event)"
      ref="StoreProductForm"
    />
    <UpdatePriceForm
      @store="handleUpdatedProduct($event)"
      ref="UpdatePriceForm"
      :pageProductIds="getPageProductIds()"
      :currentPage="getCurrentPage()"
    />
    <ExportProductForm ref="ExportProductForm" />
    <PurchaseProductForm ref="PurchaseProductForm" />

    <ProductMassEditForm
      :value="modalOpen"
      :product-ids="selectedProductIds"
      @input="modalOpen = $event"
      @close="modalOpen = false"
      @updated="handleClearSelected()"
    />

    <ProductImageGalleryModal
      ref="imageGalleryModal"
      :product-ids="selectedProductIds"
      @updated="handleClearSelected()"
    />

    <ProductImagesForm ref="productImagesRef" />
  </div>
</template>

<script>
import CompanyChip from "@/components/company/sections/CompanyChip.vue";
import ClassificacaoFiscalSelect from "@/components/product/ui/ClassificacaoFiscalSelect";
import BrandsSearch from "@/components/brands/ui/BrandsSearch.vue";
import SupplierSearch from "@/components/suppliers/ui/SupplierSearch.vue";
import CategoriesSearch from "@/components/categories/ui/CategoriesSearch.vue";
import StoreProductForm from "@/components/product/forms/StoreProductForm.vue";
import UpdatePriceForm from "@/components/product/forms/UpdatePriceForm.vue";
import ProductStockLabel from "@/components/product/ui/ProductStockLabel.vue";
import ExportProductForm from "@/components/product/forms/ExportProductForm.vue";
import PurchaseProductForm from "@/components/product/forms/PurchaseProductForm.vue";
import StockAlert from "@/components/product/ui/StockAlert.vue";
import ProductMassEditForm from "@/components/product/forms/ProductMassEditForm .vue";
import ProductImageGalleryModal from "@/components/app/forms/ProductImageGalleryModal.vue";
import MediaMixin from "@/mixins/Media/MediaMixin";
import ProductImagesForm from "@/components/product/forms/ProductImagesForm.vue";

export default {
  mixins: [MediaMixin],

  components: {
    ClassificacaoFiscalSelect,
    BrandsSearch,
    SupplierSearch,
    CategoriesSearch,
    StoreProductForm,
    UpdatePriceForm,
    CompanyChip,
    ProductStockLabel,
    ExportProductForm,
    PurchaseProductForm,
    StockAlert,
    ProductMassEditForm,
    ProductImageGalleryModal,
    ProductImagesForm,
  },

  data() {
    return {
      headers: [
        {
          text: "Imagem",
          align: "center",
          sortable: false,
          value: "image",
          width: "80px",
        },
        {
          text: "Descrição",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "Preço Av",
          value: "price_cash",
          sortable: false,
          align: "right",
          width: "10%",
        },
        {
          text: "Preço Pz",
          value: "price_forward",
          sortable: false,
          align: "right",
          width: "10%",
        },
        { text: "Status", value: "status", align: "center", width: "10%" },
      ],

      allHeaders: [
        {
          text: "Imagem",
          align: "center",
          sortable: false,
          value: "image",
          width: "80px",
        },
        {
          text: "Descrição",
          align: "start",
          sortable: false,
          value: "name",
        },

        {
          text: "Preço Av",
          value: "price_cash",
          sortable: false,
          align: "right",
          width: "10%",
        },
        {
          text: "Preço Pz",
          value: "price_forward",
          sortable: false,
          align: "right",
          width: "10%",
        },
        { text: "Status", value: "status", align: "center", width: "10%" },

        {
          text: "Clonar",
          value: "clone",
          sortable: false,
          align: "center",
        },

        {
          text: "ABC Estoque",
          value: "stock_abc_curve",
          sortable: false,
          align: "center",
        },
        {
          text: "ABC Vendas",
          value: "sale_abc_curve",
          sortable: false,
          align: "center",
        },
        {
          text: "Categoria",
          value: "category",
          sortable: false,
          align: "center",
        },
        {
          text: "Marca",
          value: "brand",
          sortable: false,
          align: "center",
        },
        {
          text: "Fornecedor",
          value: "supplier",
          sortable: false,
          align: "center",
        },
        {
          text: "Peso Bruto",
          value: "weight_gross",
          sortable: false,
          align: "center",
        },
        {
          text: "Peso Líquido",
          value: "weight_net",
          sortable: false,
          align: "center",
        },
        {
          text: "Selecionar",
          value: "checkbox",
          sortable: false,
          align: "center",
          width: "0%",
        },

        {
          text: "Lucro",
          value: "profit",
          sortable: false,
          align: "right",
        },
        {
          text: "Alteração de custo",
          value: "cost_updated_at",
          sortable: false,
          align: "right",
          width: "10%",
        },
      ],

      headersABC: [
        { text: "A", value: "A" },
        { text: "B", value: " B" },
        { text: "C", value: "C" },
      ],

      showFilter: null,

      empty_filters: [
        { text: "Sem Categorias", value: "no_category" },
        { text: "Sem Marcas", value: "no_brand" },
        { text: "Sem Fornecedores", value: "no_supplier" },
        { text: "Sem Peso Bruto", value: "no_weight_gross" },
        { text: "Sem Peso Líquido", value: "no_weight_net" },
        { text: "Todos", value: "all" },
      ],

      products: {
        data: [],
      },

      selectedProductIds: [],
      modalOpen: false,

      expanded: true,

      loading: false,

      updated: [],

      searchParams: {
        manufacturer_id: null,
        status: 1,
        text: null,
        classificacao_fiscal: "00",
        category_id: null,
        supplier_id: null,
        brand_id: null,
        available_stock_more_than: null,
        available_stock_less_than: null,
        low_stock: null,
        stock_abc_curve: null,
        sale_abc_curve: null,
        //purchase_id: null,
        page: 1,
        empty_brand_or_category: "all",
      },
    };
  },

  created() {
    const categoryId = this.$route.query.category_id;
    // const categoryName = this.$route.query.category_name;

    if (categoryId) {
      this.searchParams.category_id = categoryId;
      this.expanded = false;
    }

    this.select();

    this.getPageProductIds();

    this.getCurrentPage();
  },

  watch: {
    expanded(value) {
      this.toggleExpand(value);
    },
  },

  computed: {
    pluralS() {
      return this.selectedProductIds.length > 1 ? "s" : "";
    },

    allSelected() {
      if (!this.products.data.length) return false;
      return this.products.data.every((item) =>
        this.selectedProductIds.includes(item.id)
      );
    },
  },

  methods: {
    checkIfRowIsUpdated(item) {
      if (this.updated.some((row) => item.id == row.id)) {
        return "updatedRow";
      }
      return null;
    },

    async handleClone(id) {
      if (this.$acl.can("productCreateEdit")) {
        this.$refs.StoreProductForm.clone(id);
      }
    },

    handleUpdatedProduct(product) {
      this.updated.push(product);
      this.select(this.searchParams.page);
    },

    handleRelationshipInput(relationship, field) {
      if (relationship) {
        this.searchParams[field] = relationship.id;
      } else {
        this.searchParams[field] = null;
      }

      this.select();
    },

    handleSearchInput(text) {
      this.searchParams.text = text;
      this.select();
    },

    handleUpdateCost(item) {
      if (this.$acl.can("productUpdatePrice")) {
        this.$refs.UpdatePriceForm.open(item.id);
      }
    },

    openStoreProductForm(id = null) {
      if (id ? this.$acl.canView("productCreateEdit") : this.$acl.can("productCreateEdit")) {
        this.$refs.StoreProductForm.open(id);
      }
    },

    async select(page = 1) {
      this.searchParams.page = page;

      this.loading = true;

      await this.$http
        .index("product/product", this.searchParams)
        .then((response) => {
          this.products = response.products;
          this.toggleExpand(this.expanded);
        })
        .catch((error) => {});

      this.loading = false;
    },

    toggleExpand(value) {
      for (let product of this.products.data) {
        this.$set(this.$refs.productTable.expansion, product.id, value);
      }
    },

    hasStock(productCompany) {
      if (productCompany.available_stock <= productCompany.minimum_stock) {
        return true;
      }

      if (productCompany.available_stock == 0) {
        return true;
      }

      return false;
    },

    showStockLine(productCompany) {
      if (
        productCompany.available_stock != 0 ||
        productCompany.reserved_stock != 0 ||
        productCompany.expedition_stock != 0 ||
        productCompany.physic_stock != 0 ||
        productCompany.transfer_stock != 0
      ) {
        return true;
      }

      if (productCompany.can_sell == 1) {
        return true;
      }

      return false;
    },
    openExportProductForm() {
      this.$refs.ExportProductForm.open();
    },
    openPurchaseProductForm() {
      this.$refs.PurchaseProductForm.open();
    },

    openModal() {
      this.modalOpen = true;
    },

    openImageModal() {
      this.$refs.imageGalleryModal.open();
    },

    openProductImagesModal(productId) {
      this.$refs.productImagesRef.open(productId);
    },

    handleExportSelected() {
      if (this.selectedProductIds.length === 0) {
        return;
      }

      this.$loading.start();

      this.$http
        .download("product/selected-products-export", {
          selected_product_ids: this.selectedProductIds,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `produtos-selecionados-${
              new Date().toISOString().split("T")[0]
            }.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.$loading.finish();
        })
        .catch((error) => {
          console.log(error);
          this.$loading.finish();
        });
    },

    handleClearSelected() {
      this.selectedProductIds = [];
      this.searchParams.empty_brand_or_category = "all";
      this.select(1);
    },

    toggleSelectAll() {
      if (this.allSelected) {
        // Remove todos os selecionados da página atual
        const idsOnPage = this.products.data.map((item) => item.id);
        this.selectedProductIds = this.selectedProductIds.filter(
          (id) => !idsOnPage.includes(id)
        );
      } else {
        // Adiciona todos os IDs da página atual
        const idsOnPage = this.products.data.map((item) => item.id);
        this.selectedProductIds = Array.from(
          new Set([...this.selectedProductIds, ...idsOnPage])
        );
      }
    },

    getPageProductIds() {
      return this.products.data.map((item) => item.id);
    },

    getCurrentPage() {
      return this.products.current_page || 1;
    },

    getProductImage(product) {
      if (!product.product_images || product.product_images.length === 0) {
        return null;
      }

      const productImage = product.product_images[0];

      if (!productImage) {
        return null;
      }

      return this.getImage(productImage, 'thumb');
    },
  },
};
</script>

<style>
.v-data-table__expanded__content {
  box-shadow: none !important;
  background-color: #f5f5f5;
}

.expanded-table {
  background-color: #f5f5f5 !important;
}

.expanded-table td {
  border-bottom: red !important;
}

.updatedRow {
  color: green !important;
}
</style>
